module.exports = __webpack_public_path__ + "static/media/mercedes_08.832e41e7.png";